import * as React from "react";

function Preview() {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="25" cy="25" r="25" fill="white" />
      <circle cx="25" cy="25" r="25" fill="#0074BD" fillOpacity="0.25" />
      <path
        d="M37.25 29.0547L31.8906 26.7578C30.6875 26.2109 29.3203 26.5938 28.5 27.5781L27.0234 29.3828C24.5625 27.9609 22.5391 25.9375 21.1172 23.5312L22.9766 22.0547C23.9062 21.2344 24.2891 19.8672 23.7969 18.7188L21.4453 13.25C20.8984 11.9922 19.5312 11.2812 18.1641 11.6094L13.1875 12.7578C11.875 13.0312 11 14.1797 11 15.5469C11 28.7812 21.7188 39.5 34.9531 39.5C36.3203 39.5 37.4688 38.625 37.6875 37.3125L38.8359 32.3359C39.2188 30.9688 38.5078 29.6016 37.25 29.0547ZM36.3203 31.7344L35.1719 36.7109C35.1719 36.7656 35.0625 36.875 34.9531 36.875C23.1953 36.875 13.5703 27.3047 13.5703 15.5469C13.5703 15.4375 13.6797 15.3281 13.7891 15.3281L18.7656 14.1797L18.8203 14.125C18.9297 14.125 18.9844 14.2344 19.0391 14.2891L21.3359 19.6484C21.3906 19.7578 21.3906 19.8672 21.2812 19.9219L18.6016 22.1094C18.1641 22.4922 18 23.1484 18.2734 23.6953C20.0781 27.3594 23.0859 30.3672 26.75 32.1719C27.2969 32.4453 28.0078 32.3359 28.3906 31.8438L30.5781 29.1641C30.6328 29.1094 30.7422 29.0547 30.8516 29.1094L36.2109 31.4062C36.3203 31.5156 36.375 31.625 36.3203 31.7344Z"
        fill="#0074BD"
      />
    </svg>
  );
}

export default Preview;
